import { render, staticRenderFns } from "./UketsukeMenu.vue?vue&type=template&id=38fc2d33&"
import script from "./UketsukeMenu.vue?vue&type=script&lang=ts&"
export * from "./UketsukeMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports